export const iconFontAwesomeHumanitarianAnchor = (
	<i className="fa-solid fa-anchor"></i>
);
